/* eslint-disable max-len */
import React from 'react';
function AssignmentTurnedInOutlined() {
    return (React.createElement("g", null,
        React.createElement("path", { d: "M18 9l-1.41-1.42L10 14.17l-2.59-2.58L6 13l4 4z" }),
        React.createElement("path", { d: "M19 3h-4.18C14.4 1.84 13.3 1 12 1c-1.3 0-2.4.84-2.82 2H5c-.14 0-.27.01-.4.04-.39.08-.74.28-1.01.55-.18.18-.33.4-.43.64-.1.23-.16.49-.16.77v14c0 .27.06.54.16.78s.25.45.43.64c.27.27.62.47 1.01.55.13.02.26.03.4.03h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7-.25c.41 0 .75.34.75.75s-.34.75-.75.75-.75-.34-.75-.75.34-.75.75-.75zM19 19H5V5h14v14z" })));
}
export default AssignmentTurnedInOutlined;
